import * as React from 'react';
import { compose, lifecycle, setDisplayName, withHandlers, withState } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { getUsers } from 'api';
import { ReportSettings, ReportSettingsChangeHandler } from 'logic/reports/ReportSettings';
import { Input } from 'ui/shared/Input';
import { Select } from 'ui/shared/Select';

import './UsersSection.css';

export type OwnProps = {
    reportSettings: Readonly<ReportSettings>;
    onChange: ReportSettingsChangeHandler;
};

const RawGeneralSection = ({
    username,
    allUsers,
    onChangeUsernameInput,
    onChangeUsername,
    t,
}: Props) =>
    <table id="edit-report-usernames-table">
        <tbody>
            { allUsers.length === 0 && <tr>
                <td>
                    { t('WC_REPORT_SELECT_USER') }
                </td>
                <td className="inline-child-divs">
                    <Input
                        id="edit-report-username-input"
                        value={ username }
                        onChange={ onChangeUsernameInput }
                    />
                </td>
            </tr> }
            { allUsers.length > 0 && <tr>
                <td>
                    { t('WC_REPORT_SELECT_USER') }
                </td>
                <td>
                    <Select
                        id="edit-report-username"
                        value={ username }
                        onChange={ onChangeUsername }
                    >
                        <option key="" value="">
                            { t('WC_REPORT_SELECT_ALL_USERS') }
                        </option>
                        { allUsers.map(u =>
                            <option
                                key={ u.username }
                                value={ u.username }
                            >
                                { u.display }
                            </option>
                        ) }
                    </Select>
                </td>
            </tr> }
        </tbody>
    </table>
;

type User = {
    username: string;
    display: string;
};
type RecomposeProps = {
    username: string;
    allUsers: User[];
    onChangeUsernameInput: React.ChangeEventHandler<HTMLInputElement>;
    onChangeUsername: React.ChangeEventHandler<HTMLSelectElement>;
};
type _RecomposeProps = RecomposeProps & {
    _setUsername: (s: string) => void;
    _setAllUsers: (u: User[]) => void;
};

type Props = OwnProps & _RecomposeProps & TranslateProps;

export const UsersSection = compose<Props, OwnProps>(
    setDisplayName('UsersSection'),
    translate(),
    withState('username', '_setUsername', ({ reportSettings }: OwnProps) =>
        reportSettings.username || ''
    ),
    withState('allUsers', '_setAllUsers', []),
    withHandlers<Props, Partial<RecomposeProps>>({
        onChangeUsernameInput: ({ _setUsername, onChange }) => (e: React.ChangeEvent<HTMLInputElement>) => {
            const username = e.target.value;
            _setUsername(username);
            onChange(reportSettings => reportSettings.setUsername(username));
        },
        onChangeUsername: ({ _setUsername, onChange }) => (e: React.ChangeEvent<HTMLSelectElement>) => {
            const username = e.target.value;
            _setUsername(username);
            onChange(reportSettings => reportSettings.setUsername(username));
        },
    }),
    lifecycle<Props, {}>({
        async componentDidMount() {
            try {
                const users = await getUsers();
                this.props._setAllUsers(Object.keys(users).map(username => {
                    const name = users[username].name;
                    return { username, display: !name ? username : `${username} (${name})` };
                }));
            }
            catch (err) {
                console.error(err);
            }
        },
    }),
)(RawGeneralSection);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/users/UsersSection.tsx